module.exports = __webpack_public_path__ + "img/编组.60b60ca7.png";